
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const PDFViewer: React.FC = () => {
  const { filename } = useParams<{ filename: string }>();
  const navigate = useNavigate();

  if (!filename) {
    navigate('/404');
    return null;
  }

  const decodedFilename = decodeURIComponent(filename);
  const pdfUrl = `/documents/${decodedFilename}`;

  const handleDownload = async () => {
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = decodedFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('ダウンロードエラー:', error);
      // フォールバック: 新しいタブで開く
      window.open(pdfUrl, '_blank');
    }
  };

  const handleBack = () => {
    navigate('/research-papers');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* ヘッダー */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button
              onClick={handleBack}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              <span className="font-medium">研究論文一覧に戻る</span>
            </button>
            
            <div className="flex items-center space-x-4">
              <h1 className="text-lg font-semibold text-gray-900 truncate max-w-md">
                {decodedFilename.replace('.pdf', '')}
              </h1>
              <button
                onClick={handleDownload}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center space-x-2 whitespace-nowrap"
              >
                <i className="ri-download-line"></i>
                <span>ダウンロード</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* PDF表示エリア */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="aspect-[3/4] w-full">
            <iframe
              src={pdfUrl}
              className="w-full h-full border-0"
              title={`PDF Viewer - ${decodedFilename}`}
            />
          </div>
        </div>

        {/* ダウンロード促進エリア */}
        <div className="mt-8 bg-blue-50 rounded-lg p-6 text-center">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <i className="ri-information-line text-blue-600 text-2xl"></i>
            <h3 className="text-lg font-semibold text-blue-900">
              PDFファイルをダウンロードしてご利用ください
            </h3>
          </div>
          <p className="text-blue-700 mb-6">
            ブラウザで表示される場合、ダウンロードボタンをクリックしてファイルを保存してください。
          </p>
          <button
            onClick={handleDownload}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-medium transition-colors flex items-center space-x-2 mx-auto whitespace-nowrap"
          >
            <i className="ri-download-2-line text-xl"></i>
            <span>今すぐダウンロード</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;
